export default (currentPhase: string) =>
  currentPhase
    .split('-')
    .filter((el, i) => i < 2)
    .join('-');
